export default "__VITE_ASSET__DFsx2Qu$__"